<template>
<div class="chapter">
<div class="inner_page">
<div class="contents">
<p class="contentsHead"><a id="TOC1">Contents</a></p><a id="TOC1">
</a><p class="contentsEntry"><a id="TOC1"></a><span href="#/e9781338184655_title001#tp01" title="Link target outside of Sample">Title Page</span></p>
<p class="contentsEntry"><span href="#/e9781338184655_ded001#ded01" title="Link target outside of Sample">Dedication</span></p>
<p class="contentsEntry"><a href="#/e9781338184655_ch001#ch1">Chapter 1: Triple Trouble</a></p>
<p class="contentsEntry"><a href="#/e9781338184655_ch002#ch2">Chapter 2: The Offer</a></p>
<p class="contentsEntry"><span href="#/e9781338184655_ch003#ch3" title="Link target outside of Sample">Chapter 3: Emergency!</span></p>
<p class="contentsEntry"><span href="#/e9781338184655_ch004#ch4" title="Link target outside of Sample">Chapter 4: Quartered</span></p>
<p class="contentsEntry"><span href="#/e9781338184655_ch005#ch5" title="Link target outside of Sample">Chapter 5: The Chase</span></p>
<p class="contentsEntry"><span href="#/e9781338184655_ch006#ch6" title="Link target outside of Sample">Chapter 6: Yummy Letter</span></p>
<p class="contentsEntry"><span href="#/e9781338184655_ch007#ch7" title="Link target outside of Sample">Chapter 7: No Substitute</span></p>
<p class="contentsEntry"><span href="#/e9781338184655_ch008#ch8" title="Link target outside of Sample">Chapter 8: Back to the Lab</span></p>
<p class="contentsEntry"><span href="#/e9781338184655_ch009#ch9" title="Link target outside of Sample">Chapter 9: The Shot Heard ’Round the Town</span></p>
<p class="contentsEntry"><span href="#/e9781338184655_ch010#ch10" title="Link target outside of Sample">Chapter 10: Van of Doom</span></p>
<p class="contentsEntry"><span href="#/e9781338184655_ch011#ch11" title="Link target outside of Sample">Chapter 11: False Information</span></p>
<p class="contentsEntry"><span href="#/e9781338184655_ch012#ch12" title="Link target outside of Sample">Chapter 12: This Means War!</span></p>
<p class="contentsEntry"><span href="#/e9781338184655_ch013#ch13" title="Link target outside of Sample">Chapter 13: Carob Empire</span></p>
<p class="contentsEntry"><span href="#/e9781338184655_bm001#bm1" title="Link target outside of Sample">Sneak Peek</span></p>
<p class="contentsEntry"><span href="#/e9781338184655_ata" title="Link target outside of Sample">About the Author</span></p>
<p class="contentsEntry"><span href="#/e9781338184655_bm007" title="Link target outside of Sample">Also Available</span></p>
<p class="contentsEntry"><span href="#/e9781338184655_copy001#cop01" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781338184655_toc001.vue?5ebf014a